import FortalezasAccionesListLayer from "../../components/FortalezasAccionesListLayer";

const FortalezasAccionesPage = () => {
  return <FortalezasAccionesListLayer />;
};

export default FortalezasAccionesPage;
